import { Injectable } from '@angular/core';
const JL = require('jsnlog').JL;

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class LoggerService implements PgRendererDto.LoggerService {

    constructor(
    ) {
        JL.setOptions({
            defaultAjaxUrl: `${_paragonConfig.testServerApiUrl}/api/log/js`
        });
    }

    public setAccessToken(accessToken: string) {
        const appender = JL.createAjaxAppender("header appender");
        appender.setOptions({
            "beforeSend": function (xhr) {
                xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
            }
        });

        JL().setOptions({
            "appenders": [appender]
        });
    }

    public reportDebugInfo(category: string, info: any) {
        console.log(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).debug(info);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public reportWarning(category: string, info: any) {
        console.log(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).warn(info);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public reportFatalError(category: string, info: any) {
        console.error(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).fatal(info);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public reportError(category: string, info: any) {
        console.error(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).error(info);
            } catch (error) {
                console.error(error);
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/logger.service.ts